import { css } from "@emotion/react";

import { popOverShadow } from "~/client/styles/emotion/mixins/boxShadow";
import tokens from "~/packages/design-tokens/dist/tokens";

export const buttonStyle = css({
  cursor: "pointer",
});

export const panelStyle = ({ width }) =>
  css({
    width,
    border: `1px solid ${tokens.color.border.primary.value}`,
    borderRadius: tokens.borderRadius.primary.value,
    background: tokens.color.bg.primary.default.value,
    zIndex: 10,
    ...popOverShadow(),
    "&[data-popper-placement^='top'] > #popover-arrow": {
      bottom: "-4px",
      "&:before": {
        borderBottom: `1px solid ${tokens.color.border.primary.value}`,
        borderRight: `1px solid ${tokens.color.border.primary.value}`,
      },
    },
    "&[data-popper-placement^='bottom'] > #popover-arrow": {
      top: "-4px",
      "&:before": {
        borderTop: `1px solid ${tokens.color.border.primary.value}`,
        borderLeft: `1px solid ${tokens.color.border.primary.value}`,
      },
    },
    "&[data-popper-placement^='left'] > #popover-arrow": {
      right: "-4px",
      "&:before": {
        borderRight: `1px solid ${tokens.color.border.primary.value}`,
        borderTop: `1px solid ${tokens.color.border.primary.value}`,
      },
    },
    "&[data-popper-placement^='right'] > #popover-arrow": {
      left: "-4px",
      "&:before": {
        borderLeft: `1px solid ${tokens.color.border.primary.value}`,
        borderBottom: `1px solid ${tokens.color.border.primary.value}`,
      },
    },
  });

export const arrowStyle = css({
  visibility: "hidden",
  position: "absolute",
  width: "8px",
  height: "8px",
  zIndex: "-1",

  "&:before": {
    visibility: "visible",
    position: "absolute",
    width: "8px",
    height: "8px",
    background: "inherit",
    content: '""',
    transform: "rotate(45deg)",
    backgroundColor: tokens.color.bg.primary.default.value,
  },
});
